import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ProjectCards } from "../components/ProjectCards";
import { FeaturedProjectCard } from "../components/FeaturedProjectCard";
import { categories, projects } from "../data/projectsData";

import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const hasCategory = (project, category) =>
    Array.isArray(project.category)
      ? project.category.includes(category)
      : project.category === category;

  const codingProjects = projects.filter(
    (project) => !hasCategory(project, "Leadership")
  );
  const leadershipProjects = projects.filter((project) =>
    hasCategory(project, "Leadership")
  );

  const filteredProjects =
    activeCategory === "All"
      ? codingProjects
      : codingProjects.filter((project) => hasCategory(project, activeCategory));

  const featuredProjects = filteredProjects.slice(0, 3);
  const moreProjects = filteredProjects.slice(3);

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <h2>Projects</h2>
                  <p>
                    From AI-powered applications and full-stack applications to data engineering and web scraping, I enjoy building them all! Check out some of my work below (filter by category to explore specific areas). 
                  </p>

                  <div className="project-filters">
                    {categories.map((category) => (
                      <button
                        key={category}
                        type="button"
                        className={
                          "filter-pill" +
                          (activeCategory === category ? " active" : "")
                        }
                        onClick={() => setActiveCategory(category)}
                      >
                        {category}
                      </button>
                    ))}
                  </div>

                  {featuredProjects.length > 0 && (
                    <>
                      <p className="section-label">Highlight</p>
                      <Row className="featured-grid">
                        {featuredProjects.map((project) => (
                          <Col size={12} sm={6} md={4} key={project.slug}>
                            <FeaturedProjectCard project={project} />
                          </Col>
                        ))}
                      </Row>
                    </>
                  )}

                  {moreProjects.length > 0 && (
                    <>
                      <p className="section-label">More</p>
                      <Row>
                        {moreProjects.map((project) => (
                          <ProjectCards key={project.slug} project={project} />
                        ))}
                      </Row>
                    </>
                  )}

                  {filteredProjects.length === 0 && (
                    <p>No projects in this category yet.</p>
                  )}

                  {leadershipProjects.length > 0 && (
                    <>
                      <h2 className="leadership-heading" id="leadership">
                        Leadership
                      </h2>
                      <p>
                        Projects and communities I've led to expand access to education, technology, and opportunity in Cambodia.
                      </p>
                      <Row className="featured-grid">
                        {leadershipProjects.map((project) => (
                          <Col size={12} sm={6} md={4} key={project.slug}>
                            <FeaturedProjectCard project={project} />
                          </Col>
                        ))}
                      </Row>
                    </>
                  )}
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
